import React, { useEffect, useState } from 'react';

const RoadmapComponent = () => {
  const [set, setSet] = useState(0);
  const [full, setFull] = useState(false);
  const targetY = window.innerHeight * 0.8;

  useEffect(() => {
    const sections = document.querySelectorAll('.section');
    const timeline = document.querySelector('.timeline');
    const line = document.querySelector('.line');

    function scrollHandler() {
      const scrollY = window.scrollY;
      const up = scrollY < prevScrollY;
      const down = !up;

      const timelineRect = timeline.getBoundingClientRect();
      const lineRect = line.getBoundingClientRect();

      const dist = targetY - timelineRect.top;

      if (down && !full) {
        setSet(Math.max(set, dist));
        line.style.bottom = `calc(100% - ${set}px)`;
      }

      if (dist > timeline.offsetHeight + 50 && !full) {
        setFull(true);
        line.style.bottom = `-50px`;
      }

      sections.forEach((item) => {
        const rect = item.getBoundingClientRect();

        if (rect.top + item.offsetHeight / 5 < targetY) {
          item.classList.add('show-me');
        }
      });

      prevScrollY = window.scrollY;
    }

    let prevScrollY = window.scrollY;
    scrollHandler();
    line.style.display = 'block';
    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [set, full]);

  return (
      <div className="">
        <div className="Roadmap_text  top-section">
          <h1 className='pb-2'>Start your Journey Today for a Better Tomorrow</h1>
          <p className='pb-5'>Embark on your path to a brighter future. Start your journey today, shaping a better tomorrow with endless possibilities.</p>
        </div>
        <div className="timeline container">
          <div className="line"></div>

          <div className="section">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content road_map_text">
              <h6 className=''>Professional Training:</h6>
              <p>Our program offers meticulously curated professional training modules designed to 
                equip individuals with the skills and knowledge required in today's competitive landscape. 
                From industry-specific expertise to soft skills development, we prioritize comprehensive learning to
                ensure readiness for professional challenges.
              </p>
            </div>
          </div>

          <div className="section d-flex justify-content-end">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content road_map_text">
              <h6 className=''>Peer Meets:</h6>
              <p>Our platform fosters a dynamic community where interns can engage in peer-to-peer learning, discussions, and collaborative activities. Networking opportunities within this environment allow individuals to exchange ideas, gain diverse perspectives, and build lasting connections.</p>
            </div>
          </div>

          <div className="section">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content road_map_text">
              <h6 className=''>Projects:</h6>
              <p>Engaging in hands-on projects is a pivotal aspect of our internship program. Participants get the chance to apply their learning to real-world scenarios, enabling them to develop practical skills, problem-solving abilities, and a robust portfolio showcasing their accomplishments.</p>
            </div>
          </div>

          <div className="section d-flex justify-content-end">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content road_map_text">
              <h6 className=''>Certificates:</h6>
              <p>Upon successful completion of the program, interns receive certificates validating their participation and proficiency in the various aspects of the internship. These certificates serve as a testament to their dedication, effort, and acquired skills throughout the learning journey.</p>
            </div>
          </div>

          <div className="section">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content road_map_text">
              <h6 className=''>Preparation:</h6>
              <p>We offer comprehensive guidance and resources to assist interns in preparing for their professional journey. This includes interview preparation, resume building, and skill enhancement sessions tailored to ensure they're equipped to succeed in their careers.</p>
            </div>
          </div>

          <div className="section d-flex justify-content-end">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content road_map_text">
              <h6 className=''>Interview:</h6>
              <p>As part of our program, participants receive exclusive guidance and support to excel in interviews. Mock interviews, tips from industry experts, and personalized coaching sessions are provided to enhance confidence and readiness for the job market.</p>
            </div>
          </div>

          <div className="section ">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content road_map_text">
              <h6 className=''>Placement:</h6>
              <p>Our ultimate goal is to bridge the gap between education and employment. We assist interns in securing placements by leveraging our network of industry partners and providing support throughout the application and placement process.</p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default RoadmapComponent;